import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=0212527f&"
import script from "./UploadFileModal.vue?vue&type=script&lang=js&"
export * from "./UploadFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports